export const environment = {
  production: false,
  rights: {
    viewCharts: ["gemIAM.O-GMTIK.*.KR-INT-OEBASIS", "gemIAM.O-GMTIK.OR-INT-OEIT.KR-INTADM-BPM"],
  },
};
